<div class="page-title" style="background-image: url('assets/images/landing/about/title-bg.webp')">
  <h1 class="h1-semibold head-font">How it works</h1>
</div>
<section class="page-wrap animated fadeIn">
  <div class="pt-5 d-flex flex-column">
    <div class="how-step-wrap has-animation fadeInUp">
      <div *ngFor="let item of howSteps" class="how-step {{item.alternate}}">
        <span class="icon">{{item.step}}</span>
        <div class="detail">
          <img src="{{item.img}}" />
          <div class="text">{{item.text}}</div>
          <ul class="ul-list">
            <li *ngFor="let list of item.ulText">{{list}}</li>
          </ul>
        </div>
      </div>
    </div>
    @if (!hasSession()) {
    <button class="btn btn-primary width-fit-content m-auto" type="button" [routerLink]="['/signup']">
      Get Started with Farmbox Today!
    </button>
    }
  </div>
</section>